<script>
export default {
  props: ["clr", "backClr"]
};
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <g
      id="no_approve"
      data-name="no approve"
      transform="translate(-1520 -139.006)"
    >
      <circle
        id="Ellipse_135"
        data-name="Ellipse 135"
        cx="11"
        cy="11"
        r="11"
        transform="translate(1520 139.006)"
        :fill="backClr ? backClr : 'rgba(236,72,74,0.08)'"
      />
      <g id="delete-disabled.2" transform="translate(1523 142.006)">
        <path
          id="Path_8525"
          data-name="Path 8525"
          d="M0,0H16V16H0Z"
          fill="none"
        />
        <path
          id="Path_8526"
          data-name="Path 8526"
          d="M8,8l5.333,5.333m0-5.333L8,13.333"
          transform="translate(-2.667 -2.667)"
          fill="none"
          :stroke="clr ? clr : '#a13234'"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
      </g>
    </g>
  </svg>
</template>
